import styled, { css } from 'styled-components'
import { Button, Col } from 'react-bootstrap'

const $appliedStyle = css`
  &:hover {
    background-color: ${({ theme }) => theme.palette.primary[4]};
    border-color: ${({ theme }) => theme.palette.primary[3]};
  }

  svg {
    color: ${({ theme }) => theme.palette.primary[1]} !important;
  }
`

export const DropdownButton = styled(Button)`
  padding: 0 2px;
  border: none;
  background-color: ${({ theme }) => theme.palette.grayscale[8]};
  border-radius: 0;
  width: 15px;
  line-height: 1rem;
  margin-bottom: 0.3rem;

  &:hover {
    background-color: ${({ theme }) => theme.palette.grayscale[4]};
    border-color: ${({ theme }) => theme.palette.grayscale[3]};
  }

  &:focus {
    box-shadow: none !important;
    ${({ $applied }) => $applied && $appliedStyle}
  }

  &:active svg {
    color: white
  }

  ${({ $applied }) => $applied && $appliedStyle}
  svg {
    font-size: .75rem;
    color: ${({ theme }) => theme.palette.grayscale[6]};
  }
`

export const DropdownMenu = styled(Col)`
  margin-right: 1rem;
  background-color: ${({theme}) => theme.palette.white[0]};
  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  font-weight: 200;
  padding: .5rem;
  text-align: left;
  position: absolute;
  width: auto;
  z-index: 1;

  .list-group-item:first-child label {
    font-weight: bold;
  }
`
